
import { Component, Vue, Prop } from "vue-property-decorator";
import { ZuzhijiagouList, AddComposeBumen } from "@/request/doctor";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Name extends Vue {
  private H: any = "";
  private list: any[] = [];
  private filter: any = {
    search: "",
  };
  private ifShowAddSub: boolean = false;
  private tempSub: any = {
    坐标: ["", ""],
  };
  private jingweiInput(e: any) {
    this.$forceUpdate();
  }
  /**
   * @description 获取列表数据
   */
  private fetchList() {
    const params: any = {
      params: {
        search: this.filter.search,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      data.forEach((first: any) => {
        if (first["sub_institutions"]) {
          first["sub_institutions"].forEach((second: any) => {
            second["parent_institution_id"] = first["institution_id"];
            second["上级名称"] = first["名称"];
            if (second["sub_institutions"]) {
              second["sub_institutions"].forEach((third: any) => {
                third["parent_institution_id"] = second["institution_id"];
                third["上级名称"] = second["名称"];
              });
            }
          });
        }
      });
      this.list = data;
    });
  }
  /**
   * @description 打开添加下级部门弹窗
   */
  private openAddSub(inti: any) {
    this.tempSub = {
      parent_institution_id: inti.institution_id,
      level: inti.level + 1,
      上级名称: inti["名称"],
      坐标: ["", ""],
    };
    this.ifShowAddSub = true;
  }
  /**
   * @description 打开编辑下级部门弹窗
   */
  private openComposeSub(inti: any) {
    this.tempSub = inti;
    if (!this.tempSub["坐标"]) {
      this.tempSub["坐标"] = ["", ""];
    }
    this.ifShowAddSub = true;
  }
  /**
   * @description 新建或编辑下属部门
   */
  private saveSub() {
    if (!this.tempSub["名称"]) {
      this.$message.warning("部门名称必须填写");
      return;
    }
    const params = {
      institution_id: this.tempSub.institution_id,
      parent_institution_id: this.tempSub.parent_institution_id,
      level: this.tempSub.level,
      坐标: this.tempSub["坐标"],
      名称: this.tempSub["名称"],
      备注: this.tempSub["备注"],
    };
    AddComposeBumen(this, params).then((data: any) => {
      this.$message.success("保存成功");
      this.tempSub = {
        坐标: ["", ""],
      };
      this.ifShowAddSub = false;
      this.fetchList();
    });
  }
  mounted() {
    this.H = document.body.clientHeight - 50 - 14 - 14;
    this.fetchList();
  }
}
